import { apiService } from "../../services/apiService";
import { apiServiceConstants } from "../../constants/";
import {
  SiteListModel,
  SiteListResponseModal,
  ReturnDataModel,
  SearchByModel,
  SearchByResponseModal,
  DataModel,
  NetworkListResponseModal,
  NetworkListModel,
  NetworkResultModal,
} from "./OnCallLookUpModel";
import { utilService } from "../../services";
import { useNetwork } from "../../helpers/NetworkContext";



/* ON CALL LOOK UP INPUT COMPONENT */
const getOnCallLookUpSitesList = async (
  params: { reg_code: string; n2nNetworkCode: string }
): Promise<SiteListResponseModal> => {
  console.log(params.n2nNetworkCode,"params")
  const query = `reg_code=${params.reg_code}&n2n_network=${params.n2nNetworkCode}`;

  const respApi = await apiService
    .apiCall(
      `hospital/client/?${query}`,
      {}, // pass empty object, since you already added params to URL
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as SiteListModel;
      const returnResult = setSiteResult(response);
      const result: SiteListResponseModal = {
        isSuccess: true,
        siteData: returnResult,
        status: response.status,
        message: response.message,
      };
      return result;
    })
    .catch((error) => {
      const result: SiteListResponseModal = {
        isSuccess: false,
        message: error.message,
        status: error.status,
      };
      return result;
    });

  return respApi;
};

const getOnCallLookUpNetworksList = async (
  params: object
): Promise<NetworkListResponseModal> => {
  const respApi = await apiService
    .apiCall(
      `n2n-communication/networks?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {  
      const response = res as NetworkListModel;
      const returnResult = setNetworkResult(response);
      const result: NetworkListResponseModal = {
        isSuccess: true,
        networkData: returnResult,
        status: response.status,
        message: response.message,
      };
      return result;
    })
    .catch((error) => {
      const result: NetworkListResponseModal = {
        isSuccess: false,
        message: error.message,
        status: error.status,
      };
      return result;
    });
  return respApi;
};

const setSiteResult = (response: SiteListModel) => {
  const siteData = {
    totalCount: response.result?.[0]?.count,
    data: response.result?.[0]?.data,
  };
  return siteData;
};

const setNetworkResult = (response: NetworkListModel): NetworkResultModal => {
  return {
    totalCount: response.result.length,
    data: response.result,
  };
};


/* ON CALL LOOK UP SEARCH BY COMPONENT */

/**
 * For speciality group, the key list_all will be true and
 * for individual provider , the key skip_group will be true
 */
const getParamsForSearchByComp = (
  data: ReturnDataModel,
  searchText: string
) => {
  let returnParams = {
    page: 1,
    location_id: data.SiteSelected,
    search: searchText,
    reg_code: utilService.getNetwork(),
  };
  if (data.OptionSelected === "speciality") {
    Object.assign(returnParams, { list_all: true });
  }
  if (data.OptionSelected === "individual_provider") {
    Object.assign(returnParams, { skip_group: true });
  }
  return returnParams;
};

/*
 * Function to return the api url based on its group name
 */
const getUrl = (searchParams: ReturnDataModel, selectedNetwork?: string) => {
  const regCode = utilService.getNetwork();

  switch (searchParams.OptionSelected) {
    case "group":
      return `user/group/?reg_code=${regCode}&n2n_network=${selectedNetwork}`;
    case "speciality":
      return `user/specialization/?reg_code=${regCode}&n2n_network=${selectedNetwork}`;
    case "individual_provider":
      return `user/list/?reg_code=${regCode}&n2n_network=${selectedNetwork}`; // ✅ added missing &
    default:
      return "";
  }
};

const getSearchByResult = async (
  params: Object,
  searchParams: Object, // use specific type for clarity
  selectedNetwork: string
): Promise<SearchByResponseModal> => {
  const respApi = await apiService
    .apiCall(
      getUrl(searchParams, selectedNetwork), // correctly pass selectedNetwork
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as SearchByModel;
      const returnResult = setSearchResponseModal(response, searchParams);
      return {
        isSuccess: true,
        resultData: returnResult,
        status: response.status,
        message: response.message,
      };
    })
    .catch((error) => {
      return {
        isSuccess: false,
        status: error.status,
        message: error.message,
      };
    });

  return respApi;
};
/**
 * Function to return data based on its group
 */
const setSearchResponseModal = (
  response: SearchByModel,
  searchParams: ReturnDataModel
) => {
  let returnData;
  if (searchParams.OptionSelected === "speciality") {
    returnData = {
      data: response.result,
    };
  } else if (searchParams.OptionSelected === "individual_provider") {
    returnData = {
      totalCount: response.result?.[0]?.count,
      data: mapDataForIndividualProviders(response),
    };
  } else {
    returnData = {
      totalCount: response.result?.[0]?.count,
      data: response.result?.[0]?.data,
    };
  }
  return returnData;
};

/**
 * Function to map data only for individual provide; need to bind guid also.
 */
const mapDataForIndividualProviders = (response: SearchByModel) => {
  const data = response.result?.[0]?.data;
  var result: DataModel[] = data.map((item) => ({
    id: (item as any).id,
    name: (item as any).text,
    guid: (item as any).guid,
    designation: (item as any).designation,
  }));
  return result;
};

const setCaseHistoryProviderList = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/assign-emergency-provider/?reg_code=${params.reg_code}&hour=${params.hour}&minute=${params.minute}&date=${params.date}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const resp = res as any;
      const result: any = {
        message: resp.message,
        status: resp.status,
        isSuccess: resp.isSuccess,
        result: resp.result,
      };
      console.log(result);
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const setProviderList = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/sboard-schedules/doctor-v2/?reg_code=${params.reg_code}&bedId=${params.bedId}&hour=${params.hour}&minute=${params.minute}&date=${params.date}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const resp = res as any;
      const result: any = {
        message: resp.message,
        status: resp.status,
        isSuccess: resp.isSuccess,
        result: resp.result,
      };
      console.log(result);
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const setPrimaryMDList = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/primary_md-add/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const resp = res as any;
      const result: any = {
        message: resp.message,
        status: resp.status,
        isSuccess: resp.isSuccess,
        result: resp.result,
      };
      console.log(result);
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const updateCommonProviderDetails = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/commonprovider/list/${
        params.id
      }/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.PUT,
      utilService.getDeviceType()
    )
    .then((res) => {
      const resp = res as any;
      const result: any = {
        message: resp.message,
        status: resp.status,
        isSuccess: resp.isSuccess,
        result: resp.result,
      };
      console.log(result);
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const handleErrorResponse = () => {};
/*On call look up service */
export const OnCallLookUpInputService = {
  setPrimaryMDList,
  setProviderList,
  getOnCallLookUpSitesList,
  getOnCallLookUpNetworksList,
  getParamsForSearchByComp,
  getSearchByResult,
  handleErrorResponse,
  updateCommonProviderDetails,
  setCaseHistoryProviderList,
};
